module.exports = __webpack_public_path__ + "static/media/Bg.f9b74d70.png";